/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_Q1Inputs */

const en_dr_faq_q1 = /** @type {(inputs: Dr_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do participants need an account?`)
};

const id_dr_faq_q1 = /** @type {(inputs: Dr_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peserta perlu akun?`)
};

/**
* | output |
* | --- |
* | "Do participants need an account?" |
*
* @param {Dr_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_q1 = /** @type {((inputs?: Dr_Faq_Q1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_Q1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_q1(inputs)
	return en_dr_faq_q1(inputs)
});